import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const BEFORE = ['Search', 'Download', 'Search Again'];
const AFTER = ['Find', 'Teach', 'Review', 'Reuse'];
export function FromScattered() {
  return <section aria-labelledby="scattered-title" className="w-full bg-white px-3 py-6 sm:px-5" data-id="element-97" data-mp="2g52pt9bc1t9a">
      <div className="mx-auto max-w-3xl text-center" data-id="element-98" data-mp="2l349nwgl1wlt">
        <h2 id="scattered-title" className="font-head text-xl uppercase leading-[0.98] text-navy sm:text-3xl" data-id="element-99" data-mp="2l3vt68wwo3vq">
          From scattered resources...
          <span className="mt-0.5 block text-green" data-id="element-100" data-mp="3cvbp4tkcr2ym">To one complete system.</span>
        </h2>

        <div className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-101" data-mp="2yvk4i9zbyobn">
          <div className="rounded-xl border border-coral/30 bg-coral/5 p-3" data-id="element-102" data-mp="2yx50m41amfbm">
            <p className="font-head text-[11px] uppercase tracking-widest text-coral" data-id="element-103" data-mp="33skaym03dt3a">Instead of:</p>
            <div className="mt-1.5 flex flex-wrap items-center justify-center gap-1.5" data-id="element-104" data-mp="1neanrv7l6ae1">
              {BEFORE.map((step, index) => <span key={step} className="flex items-center gap-1.5" data-id="element-105" data-mp="1scvn7sf0kq1f" data-mpi={index}>
                  {index > 0 && <ArrowRightIcon className="h-3.5 w-3.5 text-coral" aria-hidden="true" data-id="element-106" data-mp="3hzd39wwqg5mc" />}
                  <span className="rounded-md bg-white px-2 py-1 font-head text-[11px] uppercase text-navy sm:text-[13px]" data-id="element-107" data-mp="3dz2l7lvo1or4">
                    {step}
                  </span>
                </span>)}
            </div>
          </div>

          <div className="rounded-xl border border-green/30 bg-green/5 p-3" data-id="element-108" data-mp="3n0ivzuqe7svv">
            <p className="font-head text-[11px] uppercase tracking-widest text-green-dark" data-id="element-109" data-mp="4qqiswerbpu9">You get:</p>
            <div className="mt-1.5 flex flex-wrap items-center justify-center gap-1.5" data-id="element-110" data-mp="qptuhu17w8y">
              {AFTER.map((step, index) => <span key={step} className="flex items-center gap-1.5" data-id="element-111" data-mp="ek7a9trf8sur" data-mpi={index}>
                  {index > 0 && <ArrowRightIcon className="h-3.5 w-3.5 text-green" aria-hidden="true" data-id="element-112" data-mp="9lcul0or3kev" />}
                  <span className="rounded-md bg-white px-2 py-1 font-head text-[11px] uppercase text-navy sm:text-[13px]" data-id="element-113" data-mp="ogsg2hb9m7zn">
                    {step}
                  </span>
                </span>)}
            </div>
          </div>
        </div>

        <p className="mt-2.5 text-[13px] font-semibold leading-snug text-navy" data-id="element-114" data-mp="vj7fqvtxekz5">
          Everything stays organized. Everything is ready when you need it.
        </p>
      </div>
    </section>;
}